import React from 'react';
import { Link } from 'react-router-dom';
import APPCONFIG from 'constants/Config';
import Framework from '@beardeddevops/react.framework';
import NavRightList from './NavRightList';
import PropTypes from "prop-types";


class Header extends React.Component {
	static propTypes = {
		name: PropTypes.string,
		history: PropTypes.object.isRequired,
		reloadShell: PropTypes.func.isRequired
	};

	render() {

		return (
			<Framework.Elements.Header
				rootState={rootState}
				shouldShowBrand={true}
				brandLink={<Link to="/" className="brand">
					{APPCONFIG.brand}
				</Link>}
				shouldShowLeftNav={false}
				navRight={<NavRightList name={this.props.name} history={this.props.history} reloadShell={this.props.reloadShell} kioskMode={this.props.kioskMode} />}
			/>
		);
	}
}

export default Header = Framework.Components.withRootState(Header);
